import React from "react";
import { FieldArray, useFormikContext } from "formik";
import { Button, Grid } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";
import { mastersApi } from "../../../../services/MasterDataServices";
import FormikRemoteAutocompleteField from "./FormikRemoteAutocompleteField";

export default function DimensionsFields() {
  const { values } = useFormikContext();

  const loadClassifications = React.useCallback((params) => mastersApi("object_groups", "get", null, params), []);
  const loadSubGroups = React.useCallback((params) => mastersApi("object_sub_groups", "get", null, params), []);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormikRemoteAutocompleteField
          name={"classification_id"}
          label={"Classification (Object Group)"}
          loadOptions={loadClassifications}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormikRemoteAutocompleteField
          name={"sub_group_id"}
          label={"Sub Group (Object Sub Group)"}
          loadOptions={loadSubGroups}
        />
      </Grid>

      <Grid item xs={12}>
        <FieldArray name={"items"}>
          {({ push, remove }) => (
            <Grid container spacing={2}>
              {(values?.items || []).map((_, idx) => (
                <React.Fragment key={idx}>
                  <Grid item xs={12} sm={5}>
                    <Field
                      component={TextField}
                      variant={"outlined"}
                      size={"small"}
                      fullWidth
                      label={"Label"}
                      name={`items.${idx}.label`}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Field
                      component={TextField}
                      variant={"outlined"}
                      size={"small"}
                      fullWidth
                      label={"Unit"}
                      name={`items.${idx}.unit`}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant={"outlined"}
                      color={"error"}
                      onClick={() => remove(idx)}
                      size={"small"}
                      className={"text-capitalize"}
                      fullWidth
                    >
                      Remove
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}

              <Grid item xs={12}>
                <Button
                  variant={"outlined"}
                  onClick={() => push({ label: "", unit: "" })}
                  size={"small"}
                  className={"text-capitalize"}
                >
                  Add Item
                </Button>
              </Grid>
            </Grid>
          )}
        </FieldArray>
      </Grid>
    </>
  );
}
